import React from 'react';
import PropTypes from 'prop-types';

/**
 * ScrollableFilterBar - Handles horizontal scrolling with arrow controls
 *
 * @param {object} props - Props.
 * @param {React.Node} props.children - The content to render inside the scrollable area.
 * @param {React.Node} props.settingsButton - Optional settings button to display.
 * @param {React.Node} props.roundButtons - Optional round buttons to display.
 * @param {React.Node} props.scrollableItems - Scrollable items component.
 * @param {React.Node} props.navItems - Navigation items component.
 * @param {React.Node} props.additionalNavItems - Additional navigation items.
 * @param {boolean} props.areFilterOptionsVisible - Whether filter options are visible.
 * @param {React.Ref} props.filterBarRef - Reference to filter bar element.
 * @returns {React.Element} Component.
 */
export const ScrollableFilterBar = ({
    children,
    settingsButton,
    roundButtons,
    scrollableItems,
    navItems,
    additionalNavItems,
    areFilterOptionsVisible,
    filterBarRef
}) => {
    return (
        <>
            <div className="filter-bar-wrapper">
                <div className="filter-bar" ref={filterBarRef}>
                    {scrollableItems}
                </div>

                {navItems}

                {!!settingsButton && (
                    <div className="stats-leaders-nav__filter-button-wrapper">
                        {settingsButton}
                    </div>
                )}

                {!!additionalNavItems && (
                    <div className="stats-leaders-nav__filter-button-wrapper">
                        {additionalNavItems}
                    </div>
                )}
            </div>
            {!!roundButtons && !areFilterOptionsVisible && (
                <div className="stats-leaders-nav__round-buttons-wrapper">
                    {roundButtons}
                </div>
            )}
            {children}
        </>
    );
};

ScrollableFilterBar.propTypes = {
    children: PropTypes.node,
    settingsButton: PropTypes.node,
    roundButtons: PropTypes.node,
    scrollableItems: PropTypes.node,
    navItems: PropTypes.node,
    additionalNavItems: PropTypes.node,
    areFilterOptionsVisible: PropTypes.bool,
    filterBarRef: PropTypes.object
};
